/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 全部渠道 ");
import { useModel } from '@ultra/share/hooks';
import { UseGetGameChannel } from '@/utils/hooks';
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: {
      type: [String, Number, Array, Object],
      default: undefined
    },
    gid: {
      type: [String, Number],
      default: ''
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    otherProps: {
      type: [Object],
      default: () => ({})
    },
    filterCid: {
      type: Array,
      default: () => []
    },
    all: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择渠道'
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const getGameChannel = UseGetGameChannel();
    const gameChannel = ref([]);
    const value = useModel(() => props.modelValue, val => emits('update:modelValue', val));
    watch(() => props.gid, val => {
      if (val) {
        getGameChannel({
          gid: val,
          ...props.otherProps
        }).then(data => {
          gameChannel.value = data;
        });
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_select, {
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(value) ? value.value = $event : null),
        filterable: "",
        clearable: "",
        placeholder: props.placeholder,
        multiple: __props.multiple
      }, {
        default: _withCtx(() => [__props.all ? (_openBlock(), _createBlock(_component_el_option, {
          key: 0,
          value: ""
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameChannel.value, item => {
          return _openBlock(), _createElementBlock(_Fragment, null, [!__props.filterCid.includes(item.cid) && !__props.filterCid.includes(item.channel) ? (_openBlock(), _createBlock(_component_el_option, {
            value: item.cid,
            key: item.cid,
            label: item.name
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
            _: 2
          }, 1032, ["value", "label"])) : _createCommentVNode("", true)], 64);
        }), 256))]),
        _: 1
      }, 8, ["modelValue", "placeholder", "multiple"]);
    };
  }
});